import { render, staticRenderFns } from "./HTMLText.vue?vue&type=template&id=54b8b071&scoped=true"
import script from "./HTMLText.vue?vue&type=script&lang=js"
export * from "./HTMLText.vue?vue&type=script&lang=js"
import style0 from "./HTMLText.vue?vue&type=style&index=0&id=54b8b071&prod&scoped=true&lang=scss"
import style1 from "./HTMLText.vue?vue&type=style&index=1&id=54b8b071&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b8b071",
  null
  
)

export default component.exports